class ExpiringStorage {
    get(key) {
        const cachedValue = localStorage.getItem(key)

        if (cachedValue === null) {
            return null
        }

        const cached = JSON.parse(cachedValue)

        if (!cached) {
            return null
        }

        const expires = new Date(cached.expires)

        if (expires < new Date()) {
            localStorage.removeItem(key)
            return null
        }

        return cached.value
    }

    set(key, value, lifeTimeInMinutes) {
        const currentTime = new Date().getTime()
        const expires = new Date(currentTime + lifeTimeInMinutes * 60000)
        localStorage.setItem(key, JSON.stringify({ value, expires }))
    }
}

export default new ExpiringStorage;
